import { AuditType, type PagedResultOfAuditHistoryRecord } from 'api';
import { api } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const auditTypeTagMap: Record<AuditType, 'SpeakingMonitoring' | 'EorSpeakingMonitoring'> = {
  [AuditType.SpeakingMonitoring]: 'SpeakingMonitoring',
  [AuditType.EorSpeakingMonitoring]: 'EorSpeakingMonitoring',
};

const auditApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getAuditHistory: builder.query<
      PagedResultOfAuditHistoryRecord,
      { auditType: AuditType; domainId: number; pageIndex: number; pageSize: number }
    >({
      query: ({ auditType, domainId, pageIndex, pageSize }) => {
        return api.audit.get({
          'filter.auditType': auditType,
          'filter.domainId': domainId,
          page: pageIndex + 1,
          count: pageSize,
        });
      },
      providesTags: (_result, _error, { auditType }) => [auditTypeTagMap[auditType]],
    }),
  }),
});

export const { useGetAuditHistoryQuery } = auditApi;
